import { Node, mergeAttributes } from "@tiptap/core";

export const Video = Node.create({
    name: "video",

    group: "block",

    selectable: true,

    draggable: true,

    atom: true,

    addAttributes() {
        return {
            src: {
                default: null,
                parseHTML: (element) =>
                    element.getAttribute("src") ||
                    element.querySelector("source")?.getAttribute("src"),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "video",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "video",
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                controls: "controls",
                class: "w-full rounded-lg shadow-lg mb-8",
            }),
            [
                "source",
                {
                    src: HTMLAttributes.src,
                    type: "video/mp4",
                },
            ],
        ];
    },
});
